import React from 'react';
import { problemWalls } from '../../mock/content';
import { AlertTriangle, Ban, Users } from 'lucide-react';
import Reveal from './Reveal';

const icons = [AlertTriangle, Ban, Users];

const Problem = () => {
  return (
    <section className="bg-white py-20 md:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            The problem we solve
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            Your advertisers are already buying leads. Just not from you.
          </h2>
          <p className="mt-6 text-body-muted text-[16px] leading-[1.7]">
            Every advertiser on your rate card is moving budget from media to pipeline. That money is going to demand generation vendors who have never read your title, do not know your market and hold none of your trust.
          </p>
        </div>

        <h3 className="mt-16 text-navy text-[18px] font-bold text-center">
          And when publishers try to win it back, they hit three walls.
        </h3>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {problemWalls.map((w, i) => {
            const Icon = icons[i];
            return (
              <Reveal
                key={w.title}
                delay={i * 120}
                className="bg-white rounded-2xl shadow-mk p-7 hover:shadow-mk-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br from-brand-blue to-brand-blue-light text-white shadow-mk-blue -mt-14 mb-4">
                  <Icon size={24} strokeWidth={2.2} />
                </div>
                <h4 className="text-navy text-[19px] font-bold leading-snug">{w.title}</h4>
                <p className="mt-3 text-body-muted text-[14.5px] leading-[1.7]">{w.body}</p>
              </Reveal>
            );
          })}
        </div>

        <p className="mt-14 text-navy text-[16px] font-bold text-center">
          Every one of those walls is exactly what we remove.
        </p>
        <p className="mt-3 text-body-muted text-[14.5px] leading-[1.7] max-w-[720px] mx-auto text-center">
          The backdrop makes it urgent: AI answers are cutting publisher search traffic by 15–20%, and three platforms now take 56% of global ad spend. The page-view economy is not coming back.
        </p>
      </div>
    </section>
  );
};

export default Problem;
